// @flow
import styled from 'styled-components'
import { Card } from 'antd'

export const StyledCard = styled(Card)`
  height: 100%;
`

// Empty State Container
export const ReloadDataContainer = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/container-component/style.js